import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-table-title',
  templateUrl: './table-title.component.html',
  styleUrls: ['./table-title.component.scss']
})
export class TableTitleComponent {

  @Input() introText: string;
  @Input() inboxUnreadCount: number;
  @Input() fontSize = '28px';
  @Input() title: string;

  constructor() {
  }

}
